import React, {
    createRef,
    useCallback,
    useEffect,
    useImperativeHandle,
    useMemo,
    useRef,
    useState,
} from "react"
import i18nData from "@rogue_4/locales/zh-CN.json"
import anime from "animejs"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import ANIMATION from "../../animation"
import CircleButton from "../../components/CircleButton"
import GAME_EMITTER from "../../components/Emitter"
import EquipFrame from "../../components/EquipFrame"
import ItemFrame from "../../components/ItemFrame"
import {
    useGameCraftModal,
    useGameEquipModal,
    useGameItemModal,
} from "../../components/Modal/store"
import ToastContainer from "../../components/Toast"
import { GAME_EQUIP_DICT } from "../../data/battle"
import GAME_ITEM_DICT from "../../data/item"
import { useDivRef } from "../../hooks/useDivRef"
import { getCraftResult, useGameCraft, useGameItemDict } from "../../store"
import { IAnimateRef } from "../../type"
import { SFX } from "../../utils/sound"
import { useNextScene } from "../store"
import { TypeToast } from "../trail"

import styles from "./index.module.less"

const CraftScene = React.forwardRef<IAnimateRef>((_, ref) => {
    const nextScene = useNextScene()
    const callCraftModal = useGameCraftModal()
    const callEquipModal = useGameEquipModal()
    const handleBlueprint = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation()
            callCraftModal()
        },
        [callCraftModal]
    )

    // item div refs
    const refs = useMemo(
        () =>
            new Array(6).fill(0).map((_, index) => createRef<HTMLDivElement>()),
        []
    )
    const chainRefs = useMemo(
        () =>
            new Array(6).fill(0).map((_, index) => createRef<HTMLDivElement>()),
        []
    )
    const brainRef = useDivRef()
    const brainBgRef = useDivRef()
    const brainInnerRef = useDivRef()
    const effectRef = useDivRef()
    const maskRef = useDivRef()

    // item data
    const { itemDict, equipArr, craft } = useGameCraft()
    const items = useMemo(
        () =>
            Object.entries(itemDict).map(([key, value]) => ({
                key,
                avai: value,
            })),
        [itemDict]
    )
    // logic control
    const lockRef = useRef(false)
    const lockNextRef = useRef(false)

    const [choiceArr, setChoiceArr] = useState<string[]>([])
    const handleItemClick = useCallback(
        (key: string) => {
            SFX.play("commonClick")
            if (lockNextRef.current) return
            if (lockRef.current) return
            if (!items.find((i) => i.key === key)?.avai) return
            if (choiceArr.includes(key)) {
                setChoiceArr(choiceArr.filter((s) => s !== key))
            } else {
                if (choiceArr.length >= 2) return
                else setChoiceArr([...choiceArr, key])
            }
        },
        [choiceArr, items]
    )
    const handleCraftClick = useCallback(() => {
        if (lockNextRef.current) return
        if (choiceArr.length < 2) return
        if (lockRef.current) return
        lockRef.current = true
        const complete = () => {
            lockRef.current = false
            const equip = getCraftResult(choiceArr[0], choiceArr[1])
            callEquipModal(GAME_EQUIP_DICT[equip.result], false, () => {
                craft(choiceArr[0], choiceArr[1])
            })
            setChoiceArr([])
        }
        const container = effectRef.current as HTMLDivElement
        const mask = maskRef.current as HTMLDivElement
        const heart = container.querySelector(`.${styles.bg}`) as HTMLDivElement
        const button = container.querySelector(
            `.${styles.craftButton}`
        ) as HTMLDivElement
        const effectContainer = container.querySelector(
            `.${styles.craftDeco}`
        ) as HTMLDivElement
        const effectIcon = container.querySelector(
            `.${styles.effectIcon}`
        ) as HTMLDivElement
        const effectCircle = container.querySelector(
            `.${styles.effectCircle}`
        ) as HTMLDivElement
        const effectSmoke = container.querySelector(
            `.${styles.effectSmoke}`
        ) as HTMLDivElement
        const dstScale = 1.5
        //需改回
        anime
            // .timeline()
            // .add(ANIMATION.out(heart))
            // .add(
            //     ANIMATION.out(
            //         [
            //             refs[items.findIndex((i) => i.key === choiceArr[0])]
            //                 .current!,
            //             refs[items.findIndex((i) => i.key === choiceArr[1])]
            //                 .current!,
            //         ],
            //         {},
            //         { scale: [0.7, 0.1], duration: 5 }
            //     ),
            //     0
            // )
            // .add(
            //     {
            //         targets: [
            //             chainRefs[
            //                 items.findIndex((i) => i.key === choiceArr[0])
            //             ].current!,
            //             chainRefs[
            //                 items.findIndex((i) => i.key === choiceArr[1])
            //             ].current!,
            //         ],
            //         opacity: 0,
            //         easing: "easeInCubic",
            //         duration: 3,
            //     },

            //     0
            // )
            // .add(ANIMATION.in(mask, {}, { duration: 1 }))
            // .add(
            //     {
            //         targets: button,
            //         opacity: 0,
            //         scale: [1, dstScale],
            //         duration: 1000,
            //         easing: "easeOutCubic",
            //     },
            //     45
            // )
            // .add(
            //     {
            //         targets: effectContainer,
            //         opacity: 1,
            //         scale: [1, dstScale],
            //         duration: 10,
            //         easing: "easeOutCubic",
            //     },
            //     45
            // )
            // .add(
            //     {
            //         targets: effectSmoke,
            //         begin: () => {
            //             effectSmoke.style.opacity = "1"
            //             effectSmoke.style.maskImage = `radial-gradient(circle at center, transparent 0, transparent 100%, white 150%)`
            //         },
            //         duration: 15,
            //         easing: "linear",
            //         update(anim) {
            //             effectSmoke.style.maskImage = `radial-gradient(circle at center, transparent 0, transparent ${(100 - anim.progress).toFixed(2)}%, white ${(110 - anim.progress).toFixed(2)}%)`
            //         },
            //     },
            //     45
            // )
            // .add(
            //     {
            //         begin: () => {
            //             SFX.play("craft")
            //         },
            //     },
            //     100
            // )
            // .add(
            //     {
            //         targets: effectContainer,
            //         opacity: 0,
            //         scale: [dstScale, 0],
            //         duration: 1000,
            //         easing: "easeInCubic",
            //         complete,
            //     },
            //     200
            // )
            // .add(ANIMATION.out(mask, {}, { duration: 500 }), 28)
            // .add(ANIMATION.in(button, {}, { scale: [1, 1] }), 32)
            // .add(ANIMATION.in(heart), 32)
            .timeline()
            .add(ANIMATION.out(heart))
            .add(
                ANIMATION.out(
                    [
                        refs[items.findIndex((i) => i.key === choiceArr[0])]
                            .current!,
                        refs[items.findIndex((i) => i.key === choiceArr[1])]
                            .current!,
                    ],
                    {},
                    { scale: [0.7, 0.1], duration: 500 }
                ),
                0
            )
            .add(
                {
                    targets: [
                        chainRefs[
                            items.findIndex((i) => i.key === choiceArr[0])
                        ].current!,
                        chainRefs[
                            items.findIndex((i) => i.key === choiceArr[1])
                        ].current!,
                    ],
                    opacity: 0,
                    easing: "easeInCubic",
                    duration: 300,
                },

                0
            )
            .add(ANIMATION.in(mask, {}, { duration: 1000 }))
            .add(
                {
                    targets: button,
                    opacity: 0,
                    scale: [1, dstScale],
                    duration: 1000,
                    easing: "easeOutCubic",
                },
                450
            )
            .add(
                {
                    targets: effectContainer,
                    opacity: 1,
                    scale: [1, dstScale],
                    duration: 1000,
                    easing: "easeOutCubic",
                },
                450
            )
            .add(
                {
                    targets: effectSmoke,
                    begin: () => {
                        effectSmoke.style.opacity = "1"
                        effectSmoke.style.maskImage = `radial-gradient(circle at center, transparent 0, transparent 100%, white 150%)`
                    },
                    duration: 1500,
                    easing: "linear",
                    update(anim) {
                        effectSmoke.style.maskImage = `radial-gradient(circle at center, transparent 0, transparent ${(100 - anim.progress).toFixed(2)}%, white ${(110 - anim.progress).toFixed(2)}%)`
                    },
                },
                450
            )
            .add(
                {
                    begin: () => {
                        SFX.play("craft")
                    },
                },
                1000
            )
            .add(
                {
                    targets: effectContainer,
                    opacity: 0,
                    scale: [dstScale, 0],
                    duration: 1000,
                    easing: "easeInCubic",
                    complete,
                },
                2000
            )
            .add(ANIMATION.out(mask, {}, { duration: 500 }), 2800)
            .add(ANIMATION.in(button, {}, { scale: [1, 1] }), 3200)
            .add(ANIMATION.in(heart), 3200)
    }, [
        callEquipModal,
        chainRefs,
        choiceArr,
        craft,
        effectRef,
        items,
        maskRef,
        refs,
    ])
    const [toastText, setToastText] = useState("")
    const onTypeEnd = useCallback(() => {
        const cb = () => {
            lockNextRef.current = false
            setToastText("")
            GAME_EMITTER.off("NEXT", cb)
        }
        GAME_EMITTER.on("NEXT", cb)
    }, [])
    useEffect(() => {}, [])
    useEffect(() => {
        if (equipArr.length >= 3) {
            lockNextRef.current = true
            setToastText(i18n(i18nData, "rogue_4.game.craft.finish"))
        }
    }, [equipArr])
    const handleBattleClick = useCallback(() => {
        if (lockNextRef.current) return
        if (equipArr.length >= 3) nextScene()
        // FIXME remove this
        // nextScene()
    }, [equipArr.length, nextScene])

    const bgRef = useDivRef()
    const equipContainerRef = useDivRef()
    const buttonsRef = useDivRef()
    const leftDoorRef = useDivRef()
    const rightDoorRef = useDivRef()
    const itemContainerRef = useDivRef()
    const bottomMaskRef = useDivRef()
    useImperativeHandle(
        ref,
        //需改回
        () => ({
            fadeIn: async () => {
                lockNextRef.current = true
                const inst = anime.timeline()
            //     inst.add(
            //         ANIMATION.in(
            //             [bgRef, bottomMaskRef],
            //             {},
            //             { duration: 10 }
            //         ),
            //         500
            //     )
            //     inst.add(
            //         ANIMATION.in(
            //             leftDoorRef,
            //             { right: "15rem" },
            //             { duration: 50 }
            //         ),
            //         100
            //     )
            //     inst.add(
            //         ANIMATION.in(
            //             rightDoorRef,
            //             { left: "15rem" },
            //             { duration: 50 }
            //         ),
            //         100
            //     )
            //     inst.add(
            //         ANIMATION.in(
            //             [itemContainerRef, effectRef, brainRef],
            //             {},
            //             { duration: 40, scale: [0.8, 1] }
            //         ),
            //         160
            //     )
            //     inst.add(ANIMATION.in(buttonsRef, {}, { duration: 40 }), 200)
            //     inst.add(
            //         ANIMATION.in(
            //             equipContainerRef,
            //             {},
            //             {
            //                 duration: 40,
            //                 complete: () => {
            //                     setToastText(
            //                         i18n(i18nData, "rogue_4.game.craft.trail")
            //                     )
            //                 },
            //             }
            //         ),
            //         200
            //     )

            //     return inst.finished
            // },
            // fadeOut: async () => {
            //     lockNextRef.current = true
            //     const inst = anime.timeline()
            //     inst.add(
            //         ANIMATION.out(
            //             [bgRef, bottomMaskRef],
            //             {},
            //             { duration: 10 }
            //         ),
            //         500
            //     )
            //     inst.add(
            //         ANIMATION.out(
            //             leftDoorRef,
            //             { right: "15rem" },
            //             { duration: 50 }
            //         ),
            //         0
            //     )
            //     inst.add(
            //         ANIMATION.out(
            //             rightDoorRef,
            //             { left: "15rem" },
            //             { duration: 50 }
            //         ),
            //         0
            //     )
            //     inst.add(
            //         ANIMATION.out(
            //             [itemContainerRef, effectRef, brainRef],
            //             {},
            //             { duration: 50, scale: [1, 0.8] }
            //         ),
            //         0
            //     )
            //     inst.add(
            //         ANIMATION.out(
            //             [buttonsRef, equipContainerRef],
            //             {},
            //             { duration: 50 }
            //         ),
            //         0
            //     )
            //     return inst.finished
            // },

                inst.add(
                    ANIMATION.in(
                        [bgRef, bottomMaskRef],
                        {},
                        { duration: 1000 }
                    ),
                    500
                )
                inst.add(
                    ANIMATION.in(
                        leftDoorRef,
                        { right: "15rem" },
                        { duration: 500 }
                    ),
                    1000
                )
                inst.add(
                    ANIMATION.in(
                        rightDoorRef,
                        { left: "15rem" },
                        { duration: 500 }
                    ),
                    1000
                )
                inst.add(
                    ANIMATION.in(
                        [itemContainerRef, effectRef, brainRef],
                        {},
                        { duration: 400, scale: [0.8, 1] }
                    ),
                    1600
                )
                inst.add(ANIMATION.in(buttonsRef, {}, { duration: 400 }), 2000)
                inst.add(
                    ANIMATION.in(
                        equipContainerRef,
                        {},
                        {
                            duration: 400,
                            complete: () => {
                                setToastText(
                                    i18n(i18nData, "rogue_4.game.craft.trail")
                                )
                            },
                        }
                    ),
                    2000
                )

                return inst.finished
            },
            fadeOut: async () => {
                lockNextRef.current = true
                const inst = anime.timeline()
                inst.add(
                    ANIMATION.out(
                        [bgRef, bottomMaskRef],
                        {},
                        { duration: 1000 }
                    ),
                    500
                )
                inst.add(
                    ANIMATION.out(
                        leftDoorRef,
                        { right: "15rem" },
                        { duration: 500 }
                    ),
                    0
                )
                inst.add(
                    ANIMATION.out(
                        rightDoorRef,
                        { left: "15rem" },
                        { duration: 500 }
                    ),
                    0
                )
                inst.add(
                    ANIMATION.out(
                        [itemContainerRef, effectRef, brainRef],
                        {},
                        { duration: 500, scale: [1, 0.8] }
                    ),
                    0
                )
                inst.add(
                    ANIMATION.out(
                        [buttonsRef, equipContainerRef],
                        {},
                        { duration: 500 }
                    ),
                    0
                )
                return inst.finished
            },
        }),
        [
            bgRef,
            bottomMaskRef,
            brainRef,
            buttonsRef,
            effectRef,
            equipContainerRef,
            itemContainerRef,
            leftDoorRef,
            rightDoorRef,
        ]
    )
    return (
        <div className={styles.craftScene}>
            <div className={styles.totalBg} ref={bgRef}></div>
            <div className={styles.doors}>
                <div className={styles.leftDoor} ref={leftDoorRef}></div>
                <div className={styles.rightDoor} ref={rightDoorRef}></div>
            </div>
            <div className={styles.maskBottom} ref={bottomMaskRef}></div>
            <div className={styles.circleButtons} ref={buttonsRef}>
                <CircleButton
                    className={styles.blueprintButton}
                    type="craft"
                    onClick={handleBlueprint}
                />
                <CircleButton
                    className={styles.fightButton}
                    disabled={equipArr.length < 3}
                    type="fight"
                    onClick={handleBattleClick}
                    propagation
                />
            </div>

            <div
                className={classNames(
                    styles.brainpower,
                    choiceArr.length >= 1 && styles.active1,
                    choiceArr.length >= 2 && styles.active2
                )}
                ref={brainRef}
            >
                <div className={styles.bg} ref={brainBgRef}></div>
                <div className={styles.inner} ref={brainInnerRef}></div>
            </div>
            <div ref={itemContainerRef} className={styles.itemContainer}>
                {refs.map(
                    (ref, index) =>
                        items[index]?.avai && (
                            <ItemFrame
                                key={index}
                                ref={ref}
                                status={
                                    choiceArr.includes(items[index].key)
                                        ? "bright"
                                        : choiceArr.length === 2
                                          ? "gray"
                                          : "normal"
                                }
                                onClick={() => {
                                    handleItemClick(items[index].key)
                                }}
                                className={styles[`item${index + 1}`]}
                                img={
                                    items[index]
                                        ? GAME_ITEM_DICT[items[index].key].image
                                        : ""
                                }
                            />
                        )
                )}
                <div className={styles.chainContainer}>
                    {chainRefs.map((ref, index) => (
                        <div
                            className={classNames(
                                styles.chain,
                                items[index]?.avai &&
                                    choiceArr.includes(items[index].key) &&
                                    styles.active
                            )}
                            ref={ref}
                            key={index}
                        ></div>
                    ))}
                </div>
            </div>
            <div className={styles.equipContainer} ref={equipContainerRef}>
                <EquipFrame
                    onClick={() => {
                        if (equipArr[0]) {
                            callEquipModal(
                                GAME_EQUIP_DICT[equipArr[0].key],
                                true
                            )
                        }
                    }}
                    equip={
                        equipArr[0]
                            ? GAME_EQUIP_DICT[equipArr[0].key]
                            : undefined
                    }
                />
                <EquipFrame
                    onClick={() => {
                        if (equipArr[1]) {
                            callEquipModal(
                                GAME_EQUIP_DICT[equipArr[1].key],
                                true
                            )
                        }
                    }}
                    equip={
                        equipArr[1]
                            ? GAME_EQUIP_DICT[equipArr[1].key]
                            : undefined
                    }
                />
                <EquipFrame
                    onClick={() => {
                        if (equipArr[2]) {
                            callEquipModal(
                                GAME_EQUIP_DICT[equipArr[2].key],
                                true
                            )
                        }
                    }}
                    equip={
                        equipArr[2]
                            ? GAME_EQUIP_DICT[equipArr[2].key]
                            : undefined
                    }
                />
            </div>
            <div ref={maskRef} className={styles.craftMask}></div>
            <div ref={effectRef} className={styles.craftEffect}>
                <div
                    className={classNames(
                        styles.craftButton,
                        choiceArr.length >= 2 && styles.active
                    )}
                    onClick={handleCraftClick}
                >
                    <div className={styles.decoContainer}>
                        <div className={styles.bg}></div>
                        <div className={styles.circle}></div>
                        <div className={styles.click}></div>
                    </div>
                </div>
                <div
                    className={classNames(
                        styles.craftDeco,
                        choiceArr.length >= 2 && styles.active
                    )}
                >
                    <div className={styles.effectIcon}></div>
                    <div className={styles.effectCircle}></div>
                    <div className={styles.effectSmoke}></div>
                </div>
            </div>
            <TypeToast
                className={styles.toast}
                text={toastText}
                onTypeEnd={onTypeEnd}
            ></TypeToast>
        </div>
    )
})
CraftScene.displayName = "CraftScene"

export default CraftScene
